import { BRAND_SITE_HOST } from "@/lib/brandConfig";
/**
 * Política de geo del sitio — una sola fuente para template + i18n.
 *
 * Reglas (alineadas con Index.tsx: BaseTemplateBlack vs International):
 * - País edge normalizado AR → español por defecto y bucket “Argentina / home negro”.
 * - UNKNOWN / sin geo en juaperrone.com → español por defecto (VPN, Worker sin CF-Country, etc.);
 *   si el Worker fija user_country no-AR o country no-AR en config, no se fuerza.
 * - Cookie user_country=AR → refuerzo cuando __TEMPLATE_CONFIG__ aún no está.
 * - test_country en localStorage (solo debug).
 *
 * No aplica a visitantes con país explícito no-AR (p. ej. US): ahí esta función es false.
 */

import { isAdminAppPath } from "@/lib/adminAppPath";
import { readEdgeCountryCookie } from "@/lib/i18nEdgeSync";
import { getServerTemplateConfig } from "@/lib/serverTemplateDetection";

/**
 * Código de país ISO2 o el literal UNKNOWN (fallback de useTemplateSelection sin Worker).
 */
export function normalizeCountryCode(
  code: string | null | undefined,
): string | null {
  if (code == null || typeof code !== "string") return null;
  const t = code.trim().toUpperCase();
  if (t === "UNKNOWN") return "UNKNOWN";
  if (t.length < 2) return null;
  return t.slice(0, 2);
}

/**
 * True cuando el sitio debe usar español por defecto y el mismo criterio que
 * “visitante tipo Argentina” en la home (template negro, sin wishlist internacional).
 */
export function usesSpanishDefaultForSite(): boolean {
  if (typeof window === "undefined") return false;
  if (isAdminAppPath()) return false;

  try {
    const test = localStorage.getItem("test_country");
    if (normalizeCountryCode(test) === "AR") return true;
  } catch {
    /* ignore */
  }

  const edgeCountry = readEdgeCountryCookie();
  if (edgeCountry === "AR") return true;

  const cfg = getServerTemplateConfig();
  const c = normalizeCountryCode(cfg?.country);
  if (c === "AR") return true;

  // Worker / config dicen país concreto no-AR → plantilla internacional, no bucket AR
  if (edgeCountry && edgeCountry !== "AR") return false;
  if (c && c !== "UNKNOWN" && c !== "AR") return false;

  // Sin país fiable (UNKNOWN / null): en producción el sitio es Argentina-first
  try {
    const host = window.location.hostname.replace(/^www\./, "");
    if (host === BRAND_SITE_HOST) return true;
  } catch {
    /* ignore */
  }

  return false;
}
